module.exports = __webpack_public_path__ + "img/empty-live-session.39851bda.jpg";